import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import type { Card as CardType } from '../data/types';
import styles from './Card.module.css';

interface CardProps {
  card: CardType;
  /** Render compactly when sitting inside a sorted column. */
  compact?: boolean;
  /** Quick-move buttons (shown when compact === false on the top of the deck). */
  onPickColumn?: () => void;
}

export function Card({ card, compact = false, onPickColumn }: CardProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: card.id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={`${styles.card} ${compact ? styles.compact : ''} ${isDragging ? styles.dragging : ''}`}
      {...listeners}
      {...attributes}
    >
      <span className={styles.category}>{card.category}</span>
      <h3 className={styles.name}>{card.name}</h3>
      {!compact && <p className={styles.description}>{card.description}</p>}
      {!compact && onPickColumn && (
        <button
          type="button"
          className={styles.pickBtn}
          onClick={(e) => {
            e.stopPropagation();
            onPickColumn();
          }}
        >
          choose column…
        </button>
      )}
    </article>
  );
}
